import { render, staticRenderFns } from "./CardDetailsUpdate.vue?vue&type=template&id=4ba31e3a&scoped=true"
import script from "./CardDetailsUpdate.vue?vue&type=script&lang=js"
export * from "./CardDetailsUpdate.vue?vue&type=script&lang=js"
import style0 from "./CardDetailsUpdate.vue?vue&type=style&index=0&id=4ba31e3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba31e3a",
  null
  
)

export default component.exports